export default {
    created: function() {
        this.brushes = [];
        this.widgets = [];
    }
}


// WEBPACK FOOTER //
// ./~/vue-graph/src/base/created.js